import { h, mergeProps, Transition, TransitionGroup } from 'vue';

import { propsFactory } from '@components/utils';

import type { Component, FunctionalComponent, PropType, TransitionProps } from 'vue';

export interface ITransitionProps extends TransitionProps {
  transition: string | boolean | (TransitionProps & { component?: Component });
  disabled?: boolean;
  group?: boolean;
}

export const makeTransitionProps = propsFactory(
  {
    /**
     * Анимация компонента
     */
    transition: {
      type: [Boolean, String, Object] as PropType<string | boolean | (TransitionProps & { component?: Component })>,
      default: 'fade-transition',
      validator: (value) => value !== true
    }
  },
  'transition'
);

export const CdsTransition: FunctionalComponent<ITransitionProps> = (props, { slots }) => {
  const { transition, disabled, group, ...rest } = props;
  const { component = group ? TransitionGroup : Transition, ...customProps } =
    typeof transition === 'object' ? transition : {};

  return h(
    component,
    mergeProps(
      typeof transition === 'string' ? { name: disabled ? '' : transition } : (customProps as any),
      typeof transition === 'string'
        ? {}
        : Object.fromEntries(Object.entries({ disabled, group }).filter(([_, v]) => v !== undefined)),
      rest as any
    ),
    slots
  );
};
